import axios from "axios";
import { JWT } from "../shared";
import { API_BASE_URL } from "../constants";
import { AuthService } from "../services";
import { handleConsoleError } from "../utils/common-methods";
import { apiendpoints } from "../constants/api-endpoints";

let _axioClient = null;
let isRefreshing = false;
let refreshSubscribers = [];

const axioClient = (header) => {
  _axioClient = axios.create({
    baseURL: `${API_BASE_URL}`,
    headers: header,
  });
  _axioClient.interceptors.response.use(
    (response) => response,
    async (error) => {
      const { config, response } = error;

      const originalRequest = error?.config;

      if (!response) {
      //toast.error("Server is down. Please try later.");
      console.log("Server is down. Please try later.");
    }

      if (error?.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        /*
      If refresh already running
      queue this request
    */
        if (isRefreshing) {
          return new Promise((resolve) => {
            subscribeTokenRefresh((token) => {
              config.headers.Authorization = `Bearer ${token}`;
              resolve(_axioClient(config));
            });
          });
        }

        config._retry = true;
        isRefreshing = true;

        try {
          const newToken = await refreshAccessToken();

          if (newToken) {
            onRefreshed(newToken);
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            return _axioClient(originalRequest);
          }
          else{
             JWT.removeJWT();
          AuthService.removeLoginUser();
          localStorage.clear();
          window.location.href = "/login";
          console.error("Refresh token failed...");
          }
        } catch (err) {
          JWT.removeJWT();
          AuthService.removeLoginUser();
          localStorage.clear();
          window.location.href = "/login";
          console.error("Refresh token failed", err);
        } finally {
          isRefreshing = false;
        }
      }

      return Promise.reject(error);
    },
  );
  return _axioClient;
};

const subscribeTokenRefresh = (cb) => {
  refreshSubscribers.push(cb);
};

const onRefreshed = (token) => {
  refreshSubscribers.forEach((cb) => cb(token));
  refreshSubscribers = [];
};

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token?.split(".")[1]));
    const exp = payload.exp * 1000;
    return Date.now() > exp;
  } catch {
    return true;
  }
};

const refreshAccessToken = async () => {
  const refreshToken = JWT.getRefreshJwt();
  const access_token = JWT.getJwt();
  if (!refreshToken) return null;

  try {
    const response = await fetch(
      `${API_BASE_URL}${apiendpoints.REFRESH_TOKEN}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          accessToken: access_token,
          refreshToken: refreshToken,
        }),
      },
    );

    const data = await response?.json();
    if (data?.Result && data?.Result?.accessToken) {
      JWT.setJwt(data?.Result?.accessToken);
      return data?.Result?.accessToken;
    } else {
      JWT.removeJWT();
      AuthService.removeLoginUser();
      localStorage.clear();
      window.location.href = "/login";
      console.error("Refresh token failed");
    }
  } catch (err) {
    JWT.removeJWT();
    AuthService.removeLoginUser();
    localStorage.clear();
    window.location.href = "/login";
    console.error("Refresh token failed", err);
  }

  return null;
};

const getHeader = (isAuth = false, isImage = false) => {
  let access_token = JWT.getJwt();

  if (isAuth && access_token) {
    //     if (isTokenExpired(access_token)) {
    //       refreshAccessToken().then(newToken=>{
    //  if (newToken) {
    //         access_token = newToken;
    //          console.log("AAA updated token new token :: ",newToken);
    //       }
    //       });

    //    }
    return {
      "Content-Type": isImage ? "multipart/form-data" : "application/json",
      Authorization: `Bearer ${access_token}`,
    };
  }
  return { "Content-Type": "application/json" };
};

const handleResponse = (response) => {
  if (response?.status === 200) {
    response = response?.data;
    if (
      response?.HasErrors === false &&
      response?.Result &&
      response?.Result?.isSuccess
    ) {
      return {
        isSuccess: true,
        data: response?.Result?.data,
        message: response?.Result?.message,
        recordsTotal: response?.Result?.recordsTotal,
      };
    } else {
      const message=response?.Result?.message ??(response?.Errors?.[0]?.Message || "Something went wrong");
      return { isSuccess: false, message:message  };
    }
  } else {
    return Promise.reject(new Error("Internal server error"));
  }
};

const handleError = (error) => {
  if (error?.response) {
    // Handle 400 or 401
    if (
      error?.response?.status === 400 ||
      error?.response?.status === 404 ||
      error?.response?.status === 402
    ) {
      handleConsoleError(error, "API http error");
      return Promise.reject(
        new Error(error?.response?.data?.Errors?.[0]?.Message),
      );
    } else if (error?.response?.status === 401) {
      handleConsoleError(error?.response?.data, "API http error");
      if (
        error?.response?.data?.Errors?.[0]?.Message === "User is not active" ||
        error?.response?.data?.Errors?.[0]?.Message === ""
      ) {
        // JWT.removeJWT();
        // AuthService.removeLoginUser();
        // localStorage.clear();
      }
      return Promise.reject(
        new Error(error?.response?.data?.Errors?.[0]?.Message|| "Session expired. Please login again."),
      );
    } else {
      const message = handleConsoleError(error, "API http error");
      return Promise.reject(new Error(message));
    }
  } else if (error?.request) {
    handleConsoleError("No response received", "API http error");
    return Promise.reject(new Error("No response received", "API http error"));
  } else {
    const message = handleConsoleError(error, "API http error");
    return Promise.reject(new Error(message));
  }
};

const httpCommon = {
  axioClient,
  getHeader,
  handleResponse,
  handleError,
};

export default httpCommon;
